import React from "react";
import { useFieldArray } from "react-hook-form";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import "../constants/constants.css";
import "./DownloadForm.css";
import SpecsheetButtonWhite from "../../button/specsheetButtonWhite/SpecsheetButtonWhite";

export default function Fields({ control, register, showSidebarDownloads }) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "downloadFormat",
  });

  return (
    <div className="form-wrapper">
      <ul>
        {fields.map((item, index) => {
          return (
            <li key={item.id}>
              <div className="input-container">
                <div className="inner-input-container">
                  <div className="download-link-form-wrapper">
                    <InputFieldFormArray
                      placeholder="Template"
                      label="Download name "
                      fieldRef={register(`downloadFormat[${index}].type`, {
                        required: false,
                      })}
                      name={`downloadFormat[${index}].type`}
                      key={item.id}
                    />

                    <InputFieldFormArray
                      label="Download link "
                      fieldRef={register(`downloadFormat[${index}].link`, {
                        required: false,
                      })}
                      name={`downloadFormat[${index}].link`}
                      key={item.id + 1}
                    />
                  </div>
                  <button
                    className="download-format-button delete-button"
                    type="button"
                    onClick={() => {
                      remove(index);
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </li>
          );
        })}
      </ul>

      <section>
        <button
          className="append-button"
          type="button"
          onClick={() => {
            append({ type: "", link: "" });
          }}
        >
          Add DownloadLink
        </button>
      </section>
      <section className="done-section-download">
        <SpecsheetButtonWhite type="button" handleClick={showSidebarDownloads}>
          Done
        </SpecsheetButtonWhite>
      </section>
    </div>
  );
}
